<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Karty serwisowe</h3>
        <div class="d-flex flex-row gap-3">
            <mat-form-field appearance="outline">
                <mat-label style="color: gray;">Szukaj...</mat-label>
                <input matInput (keyup)="doFilter($event)">
            </mat-form-field>
        </div>
        <div class="d-flex flex-row gap-3 flex-fill justify-content-end">
            <button mat-flat-button class="btn-with-icon big-button" color="accent" (click)="addCard()">
                <mat-icon class="big-icon">add</mat-icon> Dodaj kartę</button>
            <button mat-flat-button class="big-button" color="accent" (click)="fetchCards()">
                <mat-icon class="big-icon m-0">refresh</mat-icon>
            </button>
        </div>

    </div>
    
    <table mat-table matSort [dataSource]="dataSource" class="common-table">

        <!-- description Column -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Opis </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Typ </th>
            <td mat-cell *matCellDef="let element"> {{getType(element)}} </td>
        </ng-container>

        <!-- uuid Column -->
        <ng-container matColumnDef="uuid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> UUID </th>
            <td mat-cell *matCellDef="let element"> {{element.uuid}} </td>
        </ng-container>

        <!-- pin Column -->
        <ng-container matColumnDef="pin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>PIN</th>
            <td mat-cell *matCellDef="let element"> {{ element.pin }}</td>
        </ng-container>

        <!-- active Column -->
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aktywny</th>
            <td mat-cell *matCellDef="let element"> {{ getStatus(element)}}</td>
        </ng-container>


        <!-- Symbol Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
                <div class="action-cell">
                    <button type="button" class="btn btn-primary btn-action" (click)="editCard(element)"
                    matTooltip="Edytuj kartę"><mat-icon aria-hidden="false" aria-label="Edytuj"
                        fontIcon="edit"></mat-icon></button>
                <button type="button" class="btn btn-primary btn-action" (click)="generateQrCode(element)"
                    matTooltip="Generuj QR kod"><mat-icon aria-hidden="false" aria-label="Generuj QR kod"
                        fontIcon="qr_code"></mat-icon></button>
                <button type="button" class="btn btn-danger btn-action" (click)="deleteElement(element)"><mat-icon
                        aria-hidden="false" aria-label="Usuń" fontIcon="delete"></mat-icon></button>
                </div>
                
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
    </mat-paginator>
</div>